// Formatters ported from the prototype. Pure presentation — operate on
// numbers/dates that came from the API (server always returns cents,
// formatter converts to dollars for display).

export const centsToDollars = (cents: number): number => cents / 100;

export const fmtUSD = (cents: number): string =>
  '$' +
  centsToDollars(cents || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const fmtUSDc = (cents: number): string =>
  '$' +
  centsToDollars(cents || 0).toLocaleString('en-US', {
    maximumFractionDigits: 0,
  });

export const fmtNum = (n: number): string => (n || 0).toLocaleString('en-US');

export const fmtPct = (n: number): string => (n * 100).toFixed(1) + '%';

export const fmtDate = (iso: string): string => {
  const d = new Date(iso);
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export const fmtRelative = (iso: string): string => {
  const then = new Date(iso).getTime();
  const now = Date.now();
  const seconds = Math.max(0, Math.floor((now - then) / 1000));
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return fmtDate(iso);
};
